import React from 'react';
import { Bell } from 'lucide-react';

interface NotificationPreferencesProps {
  preferences: {
    newRequests: boolean;
    losingBids: boolean;
    winningBids: boolean;
    clientApproval: boolean;
    emailNotifications: boolean;
    inAppNotifications: boolean;
  };
  onUpdate: (field: string, value: boolean) => void;
}

export function NotificationPreferences({ preferences, onUpdate }: NotificationPreferencesProps) {
  return (
    <section className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-medium text-gray-900 flex items-center mb-4">
        <Bell className="h-5 w-5 text-indigo-600 mr-2" />
        Notification Preferences
      </h3>

      <div className="space-y-6">
        <div>
          <h4 className="text-sm font-medium text-gray-900 mb-3">Notification Channels</h4>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={preferences.emailNotifications}
                onChange={(e) => onUpdate('emailNotifications', e.target.checked)}
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-sm text-gray-700">Email Notifications</span>
            </label>
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={preferences.inAppNotifications}
                onChange={(e) => onUpdate('inAppNotifications', e.target.checked)}
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-sm text-gray-700">In-App Notifications</span>
            </label>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-medium text-gray-900 mb-3">Notification Events</h4>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={preferences.newRequests}
                onChange={(e) => onUpdate('newRequests', e.target.checked)}
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-sm text-gray-700">New Insurance Requests</span>
            </label>
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={preferences.losingBids}
                onChange={(e) => onUpdate('losingBids', e.target.checked)}
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-sm text-gray-700">When your bid is no longer the lowest</span>
            </label>
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={preferences.winningBids}
                onChange={(e) => onUpdate('winningBids', e.target.checked)}
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-sm text-gray-700">When you win a bid</span>
            </label>
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={preferences.clientApproval}
                onChange={(e) => onUpdate('clientApproval', e.target.checked)}
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-sm text-gray-700">Client approval status updates</span>
            </label>
          </div>
        </div>

        <div className="bg-gray-50 rounded-lg p-4 text-sm text-gray-600">
          <p className="mb-2 font-medium">Important Note:</p>
          <p>
            Some critical notifications (like account status changes or security alerts) cannot be disabled 
            and will always be sent to your primary email address.
          </p>
        </div>
      </div>
    </section>
  );
}